import gql from 'graphql-tag';

export const GET_LENDER_ACTIVITY_BY_STATE = gql`
  query LenderRetailActivityByState($input: LenderRetailActivityReportInput!) {
    lenderRetailActivity {
      byState(input: $input) {
        success
        error
        entity {
          state
          creditApps
        }
      }
    }
  }
`;
